<template>
  <Toolbar />
  <div class="container-xxl pb-10">
    <div class="row g-5 g-xl-8 align-items-start">
      <div class="col-xl-4">
        <div class="card card-flush profile-sidebar">
          <div class="card-body text-center pt-12 pb-0 px-9">
            <div class="profile-sidebar__photo mx-auto">
              <div
                class="image-input image-input-circle"
                data-kt-image-input="true"
                :class="userAuth.user_photo != null ? '' : 'image-input-empty'"
                :style="{ backgroundImage: `url(${require('@/assets/images/no-photo.png')})` }"
              >
                <div
                  v-if="userAuth.user_photo != null"
                  class="image-input-wrapper w-150px h-150px"
                  :style="{ backgroundImage: `url(${url(userAuth.user_photo)})` }"
                ></div>
                <div v-else class="image-input-wrapper w-150px h-150px" style="background-image: none;"></div>

                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-body shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  title=""
                  data-bs-original-title="Alterar foto"
                >
                  <i class="bi bi-pencil-fill fs-7"></i>
                  <input type="file" ref="photo" name="photo" id="photo" accept=".png, .jpg, .jpeg">
                  <input type="hidden" name="avatar_remove">
                </label>
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-body shadow"
                  data-kt-image-input-action="cancel"
                  data-bs-toggle="tooltip"
                  title=""
                  data-bs-original-title="Cancelar"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
                <span
                  class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-body shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  title=""
                  data-bs-original-title="Remover foto"
                >
                  <i class="bi bi-x fs-2"></i>
                </span>
              </div>
            </div>

            <h2 class="fs-2 fw-bolder text-gray-900 mt-8 mb-2">
              {{ form.user_name || userAuth.user_name }}
            </h2>
            <span class="text-muted fw-semibold d-block fs-6 mb-6">{{ form.user_email }}</span>

            <div class="profile-sidebar__details text-start">
              <div class="profile-sidebar__detail" v-if="form.user_phone">
                <i class="bi bi-telephone text-gray-500"></i>
                <span>{{ form.user_phone }}</span>
              </div>
              <div class="profile-sidebar__detail" v-if="form.user_cpf">
                <i class="bi bi-person-badge text-gray-500"></i>
                <span>{{ form.user_cpf }}</span>
              </div>
              <div class="profile-sidebar__detail" v-if="form.user_birthdate">
                <i class="bi bi-calendar3 text-gray-500"></i>
                <span>{{ form.user_birthdate }}</span>
              </div>
            </div>
          </div>

          <div class="profile-sidebar__account px-9 pb-9">
            <h3 class="fw-bold text-gray-900 fs-6 mb-5">Sua conta</h3>
            <div class="profile-tip d-flex align-items-start gap-4 mb-5">
              <span class="profile-tip__icon">
                <i class="bi bi-shield-check"></i>
              </span>
              <div>
                <span class="fw-bold text-gray-800 d-block mb-1">Dados protegidos</span>
                <span class="text-muted fs-7">Suas informações são usadas apenas para identificação na plataforma.</span>
              </div>
            </div>
            <div class="profile-tip d-flex align-items-start gap-4">
              <span class="profile-tip__icon profile-tip__icon--primary">
                <i class="bi bi-lock"></i>
              </span>
              <div>
                <span class="fw-bold text-gray-800 d-block mb-1">Segurança extra</span>
                <span class="text-muted fs-7">Ative a autenticação em dois fatores para proteger seu acesso.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card card-flush mb-5 mb-xl-8">
          <div class="card-header">
            <h3 class="card-title fw-bold">
              <i class="bi bi-pencil-square text-primary me-2"></i>
              Informações pessoais
            </h3>
            <div class="card-toolbar">
              <span class="text-muted fs-7">Atualize seus dados cadastrais</span>
            </div>
          </div>

          <form method="post" @submit.prevent="updateUser">
            <div class="card-body pt-5">
              <div class="row g-6">
                <div class="col-md-6">
                  <label class="form-label required fw-semibold">Nome completo</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="Seu nome"
                    v-model="form.user_name"
                    required
                  >
                </div>
                <div class="col-md-6">
                  <label class="form-label required fw-semibold">E-mail</label>
                  <input
                    type="email"
                    class="form-control form-control-solid"
                    placeholder="joao@exemplo.com"
                    v-model="form.user_email"
                    disabled
                  >
                  <div class="form-text">O e-mail não pode ser alterado por aqui.</div>
                </div>
                <div class="col-md-6">
                  <label class="form-label required fw-semibold">CPF</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="999.999.999-99"
                    v-model="form.user_cpf"
                    v-mask="'###.###.###-##'"
                    required
                  >
                </div>
                <div class="col-md-6">
                  <label class="form-label required fw-semibold">Celular</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    placeholder="(99) 9 9999-9999"
                    v-model="form.user_phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    required
                  >
                </div>
                <div class="col-md-6">
                  <label class="form-label required fw-semibold">Data de nascimento</label>
                  <input
                    type="text"
                    class="form-control form-control-solid"
                    v-mask="'##/##/####'"
                    placeholder="DD/MM/AAAA"
                    v-model="form.user_birthdate"
                    required
                  >
                </div>
                <div class="col-md-6">
                  <label class="form-label fw-semibold">Foto de perfil</label>
                  <div class="form-text mt-2">
                    Use o editor ao lado para alterar sua foto. Formatos aceitos: PNG, JPG e JPEG.
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer d-flex justify-content-end py-6">
              <button type="submit" class="btn btn-primary" :disabled="submitted">
                <span class="indicator-label" v-show="!submitted">
                  <i class="bi bi-check-lg me-1"></i>
                  Salvar alterações
                </span>
                <span class="indicator-progress" v-show="submitted">
                  Salvando...
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
            </div>
          </form>
        </div>

        <TwoFactorSection />

        <AccountDeactivateSection />
      </div>
    </div>
  </div>
</template>

<script>
import http from "../helpers/http";
import Alert from "../helpers/alert";
import {mask} from "vue-the-mask";
import str from "../helpers/str";
import Toolbar from "../components/layouts/auth/Toolbar.vue";
import TwoFactorSection from "../components/TwoFactorSection.vue";
import AccountDeactivateSection from "../components/AccountDeactivateSection.vue";

export default {
  name: "Profile",
  directives: {
    mask,
  },
  components: {
    Toolbar,
    TwoFactorSection,
    AccountDeactivateSection,
  },
  data() {
    return {
      errors: [],
      submitted: false,
      form: {
        user_name: '',
        user_email: '',
        user_cpf: '',
        user_phone: '',
        user_birthdate: '',
      }
    }
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    'form.user_birthdate': {
      handler(val) {
        if (val?.length === 10) {
          let date = moment(val, 'DD/MM/YYYY');
          if (date.isAfter(new Date())) {
            Alert.toastError('Data de nascimento não pode ser maior que hoje.');
            this.form.user_birthdate = '';
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    http.get('/users/me').then((response) => {
      let user = response.data;
      this.form.user_name = user.user_name;
      this.form.user_email = user.user_email;
      this.form.user_cpf = user.user_cpf;
      this.form.user_phone = user.user_phone;
      this.form.user_birthdate = user.user_birthdate_br;
    });

    KTImageInput.createInstances();
  },
  methods: {
    date: moment,
    url(path) {
      return str.url(path)
    },
    updateUser() {
      this.submitted = true;
      const form = new FormData();
      form.append('_method', 'put');
      form.append('user_name', this.form.user_name);
      form.append('user_cpf', this.form.user_cpf);
      form.append('user_phone', this.form.user_phone);
      form.append('user_birthdate', this.date(this.form.user_birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD'));
      if (this.$refs.photo.files.length > 0) {
        form.append('user_photo', this.$refs.photo.files[0]);
      }

      http.post(`/users/${this.userAuth.id_user}/profile`, form).then((response) => {
        Alert.toastSuccess("Usuário atualizado com sucesso.");
        this.$store.commit('auth/setUser', response.data);
      }).catch((error) => {
        if (error.response.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          Alert.toastError(error.response.data)
        }
      }).finally(() => {
        this.submitted = false;
      });
    }
  }
}
</script>

<style scoped>
.profile-sidebar {
  border: 1px solid #eff2f5;
}

.profile-sidebar__photo {
  width: fit-content;
}

.profile-sidebar__details {
  border-top: 1px dashed #e4e6ef;
  padding-top: 1.25rem;
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.profile-sidebar__account {
  border-top: 1px dashed #e4e6ef;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  text-align: left;
}

.profile-sidebar__detail {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #5e6278;
  font-size: 0.95rem;
}

.profile-sidebar__detail i {
  font-size: 1.1rem;
  width: 1.25rem;
  flex-shrink: 0;
}

.profile-tip__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  background: #f1faff;
  color: #009ef7;
  flex-shrink: 0;
}

.profile-tip__icon--primary {
  background: #e8fff3;
  color: #50cd89;
}
</style>
